import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Platforms from './pages/Platforms'
import NotFound from './pages/NotFound'

export default function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <Navbar />
      <Routes>
        <Route path="/"          element={<Home />}      />
        <Route path="/about"     element={<About />}     />
        <Route path="/services"  element={<Services />}  />
        <Route path="/platforms" element={<Platforms />} />
        {/* Catch-all: any path that isn't one of the above renders a real 404 page.
            This only fires for routes React Router itself doesn't recognize —
            it can't fix a 404 returned by a server/ingress/CDN before the app loads.
            If deep links 404 in production, the server serving dist/ needs to
            rewrite unmatched paths to index.html (see helm/templates/ingress.yaml
            and GETTING_STARTED.md#spa-routing--deep-links). */}
        <Route path="*"          element={<NotFound />}  />
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}
